import React from 'react';
import { useWindowDimensions } from 'react-native';
import { Box } from '@gluestack-ui/themed';

const AppLayout = ({ children }) => {
  // Note: on Android pixel ratio sometimes leads to 1-2px too small width
  const { width } = useWindowDimensions(); // because of device pixel ratio a float

  // round to nearest pixel and add two to eliminate all white borders to the left,
  const targetWidth = Math.ceil(width) + 1;

  return (
    <Box bg="$bgApp" width={targetWidth} height="100%">

      {children}

    </Box>
  );
};

export default AppLayout;
